import React, { useEffect, useState, useMemo, ChangeEvent, useRef } from "react";
import { ItemTypes, SideMenuDataTypes, SideMenuPropsType } from "../collapsibleMenu/CollapsibleMenuTypesNew";
import { AcknowledgementIcon, DashboardIcon, DepartmentIcon, DiagramIcon, EarlyWarningIcon, EditDepartmentIcon, EditIcon, EditUserIcon, ExpandLeftIcon, ExpandRightIcon, IconPluginSetting, IconSideMenuEmail, IconSideMenuSetup, IconThemeSetting, IconTutorials, IncidentIcon, NewWarningIcon, OrganizationIcon, RoleIcon, SearchIcon, SettingIcon, SideMenuFloodIcon, SideMenuSetupRecipientIcon, SideMenuStormSurgeIcon, SideMenuTemplateIcon, SideMenuTsunamiIcon } from "../iconSet/IconSet";
import { useLocation, useNavigate } from "react-router-dom";
import { PolicyTypes, useUserData } from "../../context/UserDataContext";
import { APIGetModuleMenuDetails } from "./SideMenuService";
import CollapsibleMenu from "../collapsibleMenu/CollapsibleMenu";
import CollapsibleMenuNew from "../collapsibleMenu/CollapsibleMenuNew";
import CollapsibleMenuSmallNew from "../collapsibleMenu/CollapsibleMenuSmallNew";
import LoadingScreen from "../loadingScreenComp/LoadingScreen";


// In your SideMenu component, update the sideMenu data structure to support nesting:

const sideMenu: SideMenuDataTypes[] = [
	{
		type: "Early Warning",
		items: [
			{
				label: "early warning",
				key: "early_warning_main",
				icons: <EarlyWarningIcon width="1rem" color="var(--color-text)" />,
				link: "#",
				children: [
					{
						label: "generate early warning",
						key: "create_warning_main",
						icons: <NewWarningIcon width="0.9rem" color="var(--color-text)" />,
						link: "/early_warning/generate_warning",
					},
					{
						label: "early warning messages",
						key: "early_warning_messages_main",
						icons: <IconSideMenuEmail width="0.9rem" color="var(--color-text)" />,
						link: "/early_warning/early_warning_messages",
					}
				],
			},
			/* {
				label: "SOS",
				key: "sos_request",
				icons: <EarlyWarningIcon width="1rem" color="var(--color-text)" />,
				link: "#",
				children: [
					{
						label: "SOS one",
						key: "create_warning_main",
						icons: <NewWarningIcon width="0.9rem" color="var(--color-text)" />,
						link: "/early_warning/generate_warning",
					},
					{
						label: "SOS two",
						key: "early_warning_messages_main",
						icons: <IconSideMenuEmail width="0.9rem" color="var(--color-text)" />,
						link: "/early_warning/early_warning_messages",
					}
				],
			} */
		],
	},
	{
		type: "Configurations",
		items: [
			{
				label: "System Managements",
				key: "system_managements",
				icons: <EarlyWarningIcon width="1rem" color="var(--color-text)" />,
				link: "#",
				children: [
					{
						label: "early warning management",
						key: "early_warning_management",
						icons: <EarlyWarningIcon width="1rem" color="var(--color-text)" />,
						link: "#",
						children: [
							{
								label: "setup workflow",
								key: "config_workflow",
								icons: <DiagramIcon width="1rem" color="var(--color-text)" />,
								link: "/sm/early_warning/workflow_diagram",
							},
							{
								label: "setup early warning templates",
								key: "create_templates",
								icons: <SideMenuTemplateIcon width="1rem" color="var(--color-text)" />,
								link: "/sm/early_warning/setup_template",
							},
							{
								label: "Acknowledgement",
								key: "acknowledgement",
								icons: <AcknowledgementIcon width="1rem" color="var(--color-text)" />,
								link: "/sm/early_warning/acknowledgement",
							},
							{
								label: "setup recipients",
								key: "setup_recipients",
								icons: <SideMenuSetupRecipientIcon width="1rem" color="var(--color-text)" />,
								link: "/sm/early_warning/setup_recipients",
							}
						]
					},
					{
						label: "Incident management",
						key: "incident_management",
						icons: <EarlyWarningIcon width="1rem" color="var(--color-text)" />,
						link: "#",
						children: [
							{
								label: "incidents",
								key: "incidents_management",
								icons: <IncidentIcon width="1rem" color="var(--color-text)" />,
								link: "/incidents/management",
							}
						]
					},
					{
						label: "Awareness management",
						key: "awareness_management",
						icons: <EarlyWarningIcon width="1rem" color="var(--color-text)" />,
						link: "#",
						children: [
							{
								label: "setup awareness",
								key: "setup_awareness",
								icons: <OrganizationIcon width="1rem" color="var(--color-text)" />,
								link: "/awareness/setup_awareness",
							},
						]
					}, 
					{
						label: "User management",
						key: "user_management_config",
						icons: <EarlyWarningIcon width="1rem" color="var(--color-text)" />,
						link: "#",
						children: [
							{
								label: "setup organization",
								key: "create_organization",
								icons: <OrganizationIcon width="1rem" color="var(--color-text)" />,
								link: "/user_management/setup_organization",
							},
							{
								label: "setup department",
								key: "create_department",
								icons: <DepartmentIcon width="1rem" color="var(--color-text)" />,
								link: "/user_management/setup_department",
							},
							{
								label: "setup roles",
								key: "create_roles",
								icons: <RoleIcon width="1rem" color="var(--color-text)" />,
								link: "/user_management/setup_roles",
							},
							{
								label: "setup user",
								key: "setup_user_config",
								icons: <EditDepartmentIcon width="1rem" color="var(--color-text)" />,
								link: "/user_management/setup_user",
							},
							{
								label: "Setup subscribers",
								key: "setup_subscribers",
								icons: <RoleIcon width="1rem" color="var(--color-text)" />,
								link: "/user_management/setup_subscribers",
							},
							{
								label: "setup groups",
								key: "setup_groups",
								icons: <OrganizationIcon width="1rem" color="var(--color-text)" />,
								link: "/user_management/setup_groups",
							}
						]
					},
					// {
					// 	label: "Simulations",
					// 	key: "simulation_management",
					// 	icons: <EditIcon width="1rem" color="var(--color-text)" />,
					// 	link: "#",
					// 	children: [
					// 		{
					// 			label: "Flood Simulation",
					// 			key: "flood_simulation_config",
					// 			icons: <SideMenuFloodIcon width="1rem" color="var(--color-text)" />,
					// 			link: "/simulations/flood",
					// 		},
					// 		{
					// 			label: "Tsunami Simulation",
					// 			key: "tsunami_simulation_config",
					// 			icons: <SideMenuTsunamiIcon width="1rem" color="var(--color-text)" />,
					// 			link: "/simulations/tsunami",
					// 		},
					// 		{
					// 			label: "Cyclone Simulation",
					// 			key: "cyclone_simulation_config",
					// 			icons: <SideMenuTsunamiIcon width="1rem" color="var(--color-text)" />,
					// 			link: "/simulations/cyclone",
					// 		},
					// 		{
					// 			label: "Storm Surge Simulation",
					// 			key: "storm_simulation_config",
					// 			icons: <SideMenuStormSurgeIcon width="1rem" color="var(--color-text)" />,
					// 			link: "/simulations/stormSurge",
					// 		},
					// 	]
					// },
					{
						label: "edit",
						key: "edit_config",
						icons: <EditIcon width="1rem" color="var(--color-text)" />,
						link: "#",
						children: [
							{
								label: "edit profile",
								key: "edit_user_config",
								icons: <EditUserIcon width="1rem" color="var(--color-text)" />,
								link: "/edit/edit_profile",
							},
						]
					},
					{
						label: "settings",
						key: "setting_config",
						icons: <SettingIcon width="1rem" color="var(--color-text)" />,
						link: "#",
						children: [
							{
								label: "theme settings",
								key: "theme_settings_config",
								icons: <IconThemeSetting width="1rem" color="var(--color-text)" />,
								link: "/settings/theme_settings",
							},
							{
								label: "plugin settings",
								key: "plugin_settings_config",
								icons: <IconPluginSetting width="1rem" color="var(--color-text)" />,
								link: "/settings/plugin_settings",
							},
							{
								label: "Messaging Configurations",
								key: "messaging_configuration",
								icons: <IconSideMenuSetup width="1rem" color="var(--color-text)" />,
								link: "/settings/msg_configuration",
							},
						]
					},
					{
						label: "help",
						key: "help",
						icons: <IconTutorials width="1rem" color="var(--color-text)" />,
						link: "#",
						children: [
							
						]
					},
				],
			},
		],
	}
];

const searchData: Map<string, string> = new Map([
	["new early warning", "/early_warning/generate_warning"],
	["generate early warning", "/early_warning/generate_warning"],
	["pending early warning", "/early_warning/early_warning_messages"],
	["approved early warning", "/early_warning/early_warning_messages"],
	["created early warning", "/early_warning/early_warning_messages"],
	["setup workflow", "/early_warning/workflow_diagram"],
	["setup", "/user_management/setup"],
	["setup organization", "/user_management/create_organization"],
	["setup departments", "/user_management/department"],
	["setup roles", "/user_management/roles"],
	["setup users", "/user_management/setup_user"],
	["setup subscribers", "/user_management/subscribers"],
	["setup groups", "/user_management/groups"],
	["setup awareness", "/user_management/setup_awareness"],
	["setup early warning templates", "/early_warning/setup_template"],
	["setup recipients", "/early_warning/setup_recipients"],
	["edit profile", "/edit/edit_profile"],
	["flood simulations", "/sim/flood"],
	["tsunami simulations", "/sim/tsunami"],
	["storm surge simulations", "/sim/stormSurge"],
	["incidents", "/incidents"],
	["acknowledgement", "/early_warning/acknowledgement"],
	["theme settings", "/settings/theme_settings"],
	["plugin settings", "/settings/plugin_settings"],
	["early warning template", "/early_warning/trigger_template"],
]) 

type LinkValues = {
	name: string;
	link: string;
}

const SideMenuNew = (props: SideMenuPropsType) => {

	const navigate = useNavigate();

	// Loading screen
	const [isLoading, setIsLoading] = useState<boolean>(false)

	const { hasPolicy, loading, isPolicyChanged, policies } = useUserData()

	const [searchResults, setSearchResults] = useState<LinkValues[]>([])

	const location = useLocation()

	const [sideMenuModuleDetails, setSideMenuModuleDetails] = useState<SideMenuDataTypes[] | undefined>(undefined)

	const fetchModules = async (): Promise<void> => {
		const response = await APIGetModuleMenuDetails();
	
		if (response.status && response.data) {
			const result: SideMenuDataTypes[] = sideMenu.map(menu => {
				if (menu.type === "Configurations") {
					return {
						...menu,
						items: menu.items.map(item => {
							if (item.key === "system_managements") {
								const childrenModules = response.data.map(module => ({
									label: `${module.moduleName} Module`,
									key: module.moduleId,
									icons: <IconTutorials width="1rem" color="var(--color-text)" />,
									link: `/training?module=${module.moduleId}`,
								}))
	
								// Filter children to exclude "help" if no modules exist
								const updatedChildren = item.children?.filter(child => {
									if (child.key === "help") {
										// Only keep help if there are modules
										return childrenModules.length > 0
									}
									return true // Keep all other children
								}).map(child => {
									if (child.key === "help" && childrenModules.length > 0) {
										return {
											...child,
											children: childrenModules
										};
									}
									return child
								});
	
								return {
									...item,
									children: updatedChildren
								}
							}
							return item
						})
					}
				}
				return menu
			})
			setSideMenuModuleDetails(result)
		}
	}

	useEffect(() => {
		const loadModules = async () => {
			setIsLoading(true)
			await fetchModules()
			setIsLoading(false)
		}
		loadModules()
	}, [isPolicyChanged])

	
	const filteredSideMenu = useMemo(() => {
		const shouldShowItem = (key: string): boolean => {
			const policyMap: Record<string, PolicyTypes> = {
				// Early Warning
				"create_warning_main": "EARLY_WARNING",
				"early_warning_messages_main": "EARLY_WARNING_MESSAGE",
				
				// System Management - Early Warning
				"config_workflow": "WORKFLOW_MANAGE",
				"create_templates": "SETUP_EARLY_WARNING_TEMPLATE",
				"acknowledgement": "ACKNOWLEDGEMENT",
				"setup_recipients": "SETUP_RECIPIENT",
				
				// Incident Management
				"incidents_management": "INCIDENT_MANGE",
				
				// Awareness Management
				"setup_awareness": "AWARENESS_MANAGE",
				
				// User Management
				"create_organization": "ORGANIZATION_MANAGE",
				"create_department": "DEPARTMENT_MANAGE",
				"create_roles": "USER_MANAGE",
				"setup_user_config": "USER_MANAGE",
				"setup_subscribers": "SETUP_SUBSCRIBER",
				"setup_groups": "SETUP_GROUP",
				
				// Simulations
				"flood_simulation_config": "FLOOD_SIMULATION",
				"tsunami_simulation_config": "TSUNAMI_SIMULATION",
				"cyclone_simulation_config": "CYCLONE_SIMULATION",
				"storm_simulation_config": "STORM_SURGE_SIMULATION",
				
				// Settings
				"theme_settings_config": "THEME_SETTING",
				"plugin_settings_config": "PLUGIN_SETTING",
				"messaging_configuration": "MASSAGE_CONFIG",
			};
	
			const policy = policyMap[key];
			if (policy) {
			return hasPolicy(policy);
			}

			// Show items without specific policy requirements
			return true;
		}
	
		// Recursive function to filter menu items at all levels
		const filterMenuItems = (items: any[]): any[] => {
			return items
			.map((item) => {
				// Check if current item should be visible based on policy
				const shouldShowCurrent = shouldShowItem(item.key)

				// If item has children, filter them recursively
				if (item.children && item.children.length > 0) {
				const filteredChildren = filterMenuItems(item.children)
				
				// Only return the item if:
				// 1. It passes policy check AND has visible children after filtering
				if (shouldShowCurrent && filteredChildren.length > 0) {
					return { ...item, children: filteredChildren }
				}
				// Don't return the item if it has no visible children (empty collapsible)
				return null
				}

				// Return leaf items that pass policy check (items without children)
				return shouldShowCurrent ? item : null
			})
			.filter((item): item is any => item !== null)
		};

		if (sideMenuModuleDetails) 
		{
			return sideMenuModuleDetails
				.map((category) => {
					const filteredItems = filterMenuItems(category.items)
					
					// Only return category if it has visible items after filtering
					if (filteredItems.length > 0) 
					{
						return { ...category, items: filteredItems }
					}
					
					return null;
				})
				.filter((category): category is SideMenuDataTypes => category !== null)
		}
		
		return [];
	}, [isPolicyChanged, sideMenuModuleDetails, policies]);

	const findValueForString = (event: ChangeEvent<HTMLInputElement>): void => {
		let links: LinkValues[] = []

		if (event.target.value === "")
		{
			links = []	
		}
		else 
		{
			for (const [key, value] of searchData.entries())
			{
				if (key.toLowerCase().includes(event.target.value.toLowerCase())){
					links.push({name: key, link: value})
				}
			}
		}
		setSearchResults(links)
	}

	const handleSearchClick = (link: string) => {
		window.location.href = link
	}

	return (
		<>
			{props.isMenuOpen ? (
				<div className={`side-menu-wrapper-full`}>
					<div className={`search-wrapper`}>
						<div className={`input-wrapper`}>
							<i>
								<SearchIcon color="var(--color-main-white)" width="1.2rem" />
							</i>
							<input type="text" placeholder="Search on BCONX" name="search" onChange={(e) => findValueForString(e)} autoComplete="off" />
							{searchResults.length > 0 && (
								<div className="search-sug-box">
									{searchResults.map((item, index) => (
										<span key={index} onClick={(e) => handleSearchClick(item.link)}>{item.name}</span>
									))}
								</div>
							)}
						</div>
						<div className={`expand-button-container`} onClick={() => props.setIsMenuOpen(false)} >
							<ExpandLeftIcon width="1.5rem" color="var(--color-text)" />
						</div>
					</div>

					<div className={`dashboard-wrapper`}>
						<div className={`button-wrapper`}>
							<button className={`button-full`} style={{backgroundColor: location.pathname === '/' ? 'var(--color-accent-bg)' : 'var(--color-side-menu-main-item-bg)', border: location.pathname === '/' ? 'none' : "0.15rem solid --color-side-menu-main-item-select-bg)", color: location.pathname === '/' ? "var(--color-main-white)" : "var(--color-text)"}} onClick={() => navigate('/')}>
								<DashboardIcon width="1.5rem" color={location.pathname === '/' ? "var(--color-main-white)" : "var(--color-text)"} />
								<span>dashboard</span>
							</button>
						</div>
					</div>

					<div className={`menu-item-wrapper`}>
						{filteredSideMenu && filteredSideMenu.map((categories, catIndex) => (
							<CollapsibleMenuNew
								key={catIndex}
								type={categories.type}
								items={categories.items}
							/>
						))}
					</div>
				</div>
			) : (
				<div className={`side-menu-wrapper-small`}>
					<div
						className={`expand-button-container`}
						onClick={() => props.setIsMenuOpen(true)}
					>
						<ExpandRightIcon width="1.5rem" color="var(--color-text)" />
					</div>
					<div className={`menu-item-wrapper-small`}>
						{filteredSideMenu && filteredSideMenu.map((categories, catIndex) => (
							<CollapsibleMenuSmallNew
								key={catIndex}
								type={categories.type}
								items={categories.items}
							/>
						))}
					</div>
				</div>
			)}

			{isLoading && (
                <LoadingScreen />
            )}
		</>
	);
};

export default SideMenuNew;